import React, { FC } from 'react';
import { M } from '@dashboard-experience/mastodon';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import Panel from '../../../Panels';
import { DrugScreening } from '../../../../types/report';
import { showDrugDispositionIndicator } from '../lib/utils';
import {
  ReportTable,
  ReportTableBody,
  ReportTableCell,
  ReportTableColumnHeader,
  ReportTableHead,
  ReportTableRow,
} from 'components/Reports/Report/MastodonReport/ReportTable';

interface Props {
  screening: DrugScreening;
}

const DrugV2HealthScreening: FC<Props> = ({
  screening: { analytes, status },
}) => (
  <Panel
    data-testid='health-screening-panel'
    title={i18n.getStr('components.healthScreening.drugScreening')}
    status={status}
    className='card-screening-results'
  >
    <div className='screening-results-category'>
      <div className='mb-4'>
        <strong>
          <T value='components.healthScreening.screeningResults' />
        </strong>
      </div>
      <ReportTable small>
        <ReportTableHead>
          <ReportTableRow>
            <ReportTableColumnHeader className='text-very-muted' width='40%'>
              <T value='components.healthScreening.analytes' />
            </ReportTableColumnHeader>
            <ReportTableColumnHeader className='text-very-muted' width='60%'>
              <T value='components.healthScreening.result' />
            </ReportTableColumnHeader>
          </ReportTableRow>
        </ReportTableHead>
        <ReportTableBody>
          {analytes.map(({ disposition, name, slug, quantity }) => (
            <ReportTableRow key={`tr-${slug}`}>
              <ReportTableCell>{name}</ReportTableCell>
              <ReportTableCell className='d-flex'>
                {showDrugDispositionIndicator(disposition, quantity) && (
                  <span className='disposition-indicator text-danger'>
                    <M.Icon icon='CircleFilled' />{' '}
                  </span>
                )}
                <span className='disposition'>{disposition || quantity}</span>
              </ReportTableCell>
            </ReportTableRow>
          ))}
        </ReportTableBody>
      </ReportTable>
    </div>
  </Panel>
);

export default DrugV2HealthScreening;
